import { useEffect, useState } from 'react';
import { getTenantsByProjectId } from '../../API/Tenant/Tenant';

function useGetProjectTenants(ProjectId) {
    const [loading, setLoading] = useState(true);
    const [tenants, setTenants] = useState([]);
    const [error, setError] = useState("");

    useEffect(() => {
        getTenants();
    }, []);

    async function getTenants() {
        try {
            const tenants = await getTenantsByProjectId(ProjectId);
            setTenants(tenants);
        } catch (e) {
            setError(e.message);
        } finally {
            setLoading(false);
        }
    }

    return [loading, tenants, error];
}

export default useGetProjectTenants;